import { Chip } from "@mui/material";
import { getStatusColor } from "utils/helpers/statusColors";

const ChipCustomize = ({ label = "", status = "", size = "md", props }) => {
  return (
    <Chip
      size={size}
      label={label ? label : getStatusColor(status).label}
      {...props}
      style={{
        backgroundColor: getStatusColor(status).color,
        color: "white",
        textTransform: "capitalize",
        minWidth: 80,
      }}
    />
  );
};

export default ChipCustomize;
